export default __webpack_public_path__ + "static/AppFace4-2fb6e7d3c3ce6320436360bbed3bae11.png";